var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "py-2 align-items-center border-bottom" },
    [
      _c("b-col", { attrs: { cols: "2" } }, [
        _c("p", { staticClass: "mb-0 w-100 deal-label text-light-gray" }, [
          _c("span", { staticClass: "text-capitalize" }, [
            _vm._v(" " + _vm._s(_vm.$tc("filogix.deal", 1)) + "#: "),
          ]),
          _vm._v(" "),
          _vm.filogixId
            ? _c("span", { staticClass: "deal-value bold text-primary" }, [
                _vm._v("\n        " + _vm._s(_vm.filogixId) + "\n      "),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "3" } }, [
        _vm._v(
          "\n    " + _vm._s(_vm._f("formatDateHour")(_vm.createdAt)) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "3" } },
        [
          _c(
            "b-row",
            { staticClass: "small-gutters" },
            [
              _c("b-col", { attrs: { cols: "auto" } }, [
                _c("div", { staticClass: "position-relative" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            disabled: _vm.filogixId,
                            placement: "left",
                            title: _vm.filogixId
                              ? _vm.$t("filogix.addAValidDealId")
                              : "",
                          },
                          expression:
                            "{\n              disabled: filogixId,\n              placement: 'left',\n              title: filogixId ? $t('filogix.addAValidDealId') : ''\n            }",
                        },
                      ],
                    },
                    [
                      _vm.showFilogixSyncStatusTooltip && _vm.filogixId
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.left",
                                  value: _vm.filogixSyncStatusTooltipText,
                                  expression: "filogixSyncStatusTooltipText",
                                  modifiers: { left: true },
                                },
                              ],
                              staticClass:
                                "mr-1 floating-icon floating-icon-left",
                            },
                            [
                              _c("icon", {
                                class: _vm.filogixSyncStatusTooltipColor,
                                attrs: {
                                  name: _vm.filogixSyncStatusTooltipIcon,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "inline-prompt",
                        {
                          class:
                            "bold text-gray" +
                            "" +
                            (_vm.statusFailed ? "" : " clickable"),
                          attrs: {
                            disabled: _vm.statusFailed,
                            "confirmation-text": _vm.$t(
                              "filogix.confirmDealSync",
                              { filogixId: _vm.filogixId }
                            ),
                          },
                          on: { accept: _vm.handleSyncClick },
                        },
                        [
                          _c(
                            "simple-button",
                            {
                              attrs: {
                                type: "white btn-sm",
                                "class-name": "w-100",
                                disabled:
                                  !_vm.allowSync ||
                                  _vm.hasIncident ||
                                  _vm.statusFailed,
                                loading: _vm.syncProgress.loading,
                                "loading-succeeded":
                                  _vm.syncProgress.loadingSucceeded,
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("global.words.syncFromExpert")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  !_vm.statusCancelled
                    ? _c("status-dropdown", {
                        attrs: {
                          "partial-sync": _vm.isPartialSync,
                          status: _vm.status,
                          loading: _vm.savingStatus,
                        },
                        on: { change: _vm.handleStatusChange },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "4" } },
        [_c("sync-error", { attrs: { status: _vm.submission, expert: true } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }